import { useNavigate } from "react-router";
import styled, { useTheme } from "styled-components/macro";
import { WxText } from "../components";
import { OrderCard } from "../components/pages/order/OrderCard";
import { OrderTerminatedCard } from "../components/pages/order/OrderTerminatedCard";
import { CustomNav } from "../components/ui/customNav/CustomNav";
import { EmptyPlaceholder } from "../components/ui/notFound/EmptyPlaceholder";
import useOrders, { OrderStatuses } from "../hooks/api/queries/useOrders";
import useJwt from "../hooks/utils/useJwt";
import { __ } from "../i18n/l10n";
import { breakpoint } from "../styles/constants";
import { appendCommitHash } from "../utils/appendHash";
import { PageWrapper } from "./Category";

export const Orders = () => {
  const theme = useTheme();
  const { data } = useOrders();
  const jwt = useJwt();
  const navigate = useNavigate();

  if (!jwt) navigate(appendCommitHash("/"));
  if (!data) return null;

  const processedOrders = data.filter(
    (order) => order.status === OrderStatuses["200-PROCESSED"]
  );

  return (
    <PageWrapper backgroundColor={theme.colors.black}>
      <CustomNav
        label={__("Orders")}
        navStyle={"cross"}
        forceDesktopLabelCenter
      />
      {data.length > 0 ? (
        <>
          <SectionStatus>
            <WxText darkMode bold text={__("In progress")} />
            <ul>
              {data
                .filter(
                  (order) => order.status !== OrderStatuses["200-PROCESSED"]
                )
                .map((order) => (
                  <li key={order.id}>
                    <OrderCard order={order} />
                  </li>
                ))}
            </ul>
          </SectionStatus>
          {processedOrders.length > 0 && (
            <SectionStatus>
              <WxText  darkMode bold text={__("Completed")} />
              <ul>
                {processedOrders.map((order) => (
                  <li key={order.id}>
                    <OrderTerminatedCard order={order} />
                  </li>
                ))}
              </ul>
            </SectionStatus>
          )}
        </>
      ) : (
        <EmptyPlaceholder type="orders" black />
      )}
    </PageWrapper>
  );
};

const SectionStatus = styled.section`
  margin-bottom: 1.25rem;
  > :first-child {
    margin-bottom: 0.625rem;

    @media (min-width: ${breakpoint}) {
      margin-bottom: 1.25rem;
    }
  }

  @media (min-width: ${breakpoint}) {
    margin-bottom: 3.75rem;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 0.625rem;

    @media (min-width: ${breakpoint}) {
      gap: 1.25rem;
      flex-wrap: wrap;
      flex-direction: row;
      > li {
        width: calc((100% - 1.25rem) / 2);
      }
    }
  }
`;
